export var ZoomControllerButtonType;
(function (ZoomControllerButtonType) {
    ZoomControllerButtonType["ZoomIn"] = "zoomIn";
    ZoomControllerButtonType["ZoomOut"] = "zoomOut";
    ZoomControllerButtonType["ResetZoom"] = "resetZoom";
    ZoomControllerButtonType["PanUp"] = "panUp";
    ZoomControllerButtonType["PanDown"] = "panDown";
    ZoomControllerButtonType["PanLeft"] = "panLeft";
    ZoomControllerButtonType["PanRight"] = "panRight";
})(ZoomControllerButtonType || (ZoomControllerButtonType = {}));
//# sourceMappingURL=button-type.js.map